import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  type CheckRegistrationServiceRequest,
  type CheckRegistrationServiceResponse,
  checkRegistrationService,
} from '@musinsa/services-curator';

export const registrationFactory = createQueryKeys('registration', {
  checkRegistration: (params: CheckRegistrationServiceRequest) => ({
    queryKey: [{ params }],
    queryFn: (): Promise<CheckRegistrationServiceResponse> => checkRegistrationService(params),
  }),
});
